const SectionErrors = Class(
	/**
	 * @lends {SectionErrors#}
	 */
	{
		route: function(){
			let error = this.url.shift();
			let errorText = '';
			switch(error){
				case 'have-team':
					errorText = D.Lang.get('profile.team.errors.have_team');
					break;
				case 'team-full':
					errorText = D.Lang.get('profile.team.errors.team_full');
					break;
			}
			return new SectionUnknown(errorText);
		}
	},
	Section
);